import { render, staticRenderFns } from "./v-feedback.vue?vue&type=template&id=0aa3dbba&scoped=true&"
import script from "./v-feedback.vue?vue&type=script&lang=js&"
export * from "./v-feedback.vue?vue&type=script&lang=js&"
import style0 from "./v-feedback.vue?vue&type=style&index=0&id=0aa3dbba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa3dbba",
  null
  
)

export default component.exports